import { useMutation, useQueryClient } from '@tanstack/react-query';

export const useCampaignMutation = ({ mutationFn, onSuccess }) => {
  const queryClient = useQueryClient();

  return useMutation(mutationFn, {
    onSuccess: ({ data }) => {
      queryClient.invalidateQueries(['getPrize']);
      queryClient.invalidateQueries(['campaignData', data.campaign.uuid]);

      if (onSuccess) onSuccess();
    },
  });
};
